import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestCoupon = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/coupon/use',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPointPresent = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/coupon/point/present',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestCoupon,
  requestPointPresent,
};
